/** Public values returned by the API serving this console, before the application is imported. */
export interface RuntimeConfig {
    api_url: string
    platform_admin_host: string
    facebook_app_id: string | null
    facebook_login_config_id: string | null
    /** The Google OAuth client for "Continue with Google"; null (or missing, from an older API) leaves it off. */
    google_client_id?: string | null
    /** The Apple Services ID for "Continue with Apple"; null (or missing, from an older API) leaves it off. */
    apple_client_id?: string | null
    /** Whether the API has a Discord application for "Continue with Discord"; missing (an older API) leaves it off. */
    discord_sign_in?: boolean
    /** Whether the API has an Instagram Login app for "Continue with Instagram"; missing (an older API) leaves it off. */
    instagram_sign_in?: boolean
    graphiql_enabled: boolean
}

let current: RuntimeConfig | undefined

export function runtimeConfig(): RuntimeConfig | undefined { return current }

export async function loadRuntimeConfig(fetchImpl: typeof fetch = fetch): Promise<void> {
    current = undefined
    const origin = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '')
    const response = await fetchImpl(`${origin}/v1/admin/config`, { cache: 'no-store', credentials: 'omit' })
    if (!response.ok) throw new Error('Could not load sign-in settings')
    const config: unknown = await response.json()
    if (!config || typeof config !== 'object') throw new Error('Invalid sign-in settings')
    const value = config as Partial<RuntimeConfig>
    if (typeof value.api_url !== 'string' || !/^https?:\/\//.test(value.api_url)
        || typeof value.platform_admin_host !== 'string' || !value.platform_admin_host
        || !(value.facebook_app_id === null || typeof value.facebook_app_id === 'string')
        || !(value.facebook_login_config_id === null || typeof value.facebook_login_config_id === 'string')
        || !(value.google_client_id == null || typeof value.google_client_id === 'string')
        || !(value.apple_client_id == null || typeof value.apple_client_id === 'string')
        || !(value.discord_sign_in == null || typeof value.discord_sign_in === 'boolean')
        || !(value.instagram_sign_in == null || typeof value.instagram_sign_in === 'boolean')
        || typeof value.graphiql_enabled !== 'boolean') throw new Error('Invalid sign-in settings')
    current = value as RuntimeConfig
}
